<div class="ticket-invite-background p-2 mt-2">
  <div class="my-2">
    <span class="fw-bold font-size-14">{{ 'ticket.invite.ticket.no.label' | translate }}: </span
    ><span class="ticket-invite-content">{{ ticketInvite.ACN }}</span>
  </div>
  <div class="my-1 d-flex align-items-center justify-content-between">
    <div>
      <span class="ticket-invite-prop-name">{{ 'ticket.invite.ticket.area.label' | translate }}: </span>
      <span class="ticket-invite-content">{{ ticketInvite.Area }}</span>
    </div>
    <div>
      <span class="ticket-invite-prop-name">{{ 'ticket.invite.ticket.row.label' | translate }}: </span>
      <span class="ticket-invite-content">{{ ticketInvite.Row }}</span>
    </div>
    <div>
      <span class="ticket-invite-prop-name">{{ 'ticket.invite.ticket.seats.label' | translate }}: </span>
      <span class="ticket-invite-content">{{ ticketInvite.Seat }}</span>
    </div>
  </div>
</div>
